// Open video dialog modal
document.querySelectorAll('a[href="#video"]').forEach(function (element) {
    element.addEventListener("click", () => {
        document.querySelector(`.videoplayer`).showModal();
        document.querySelector("body").classList.add("noScroll");
    });
});


// Close dialog modal
document.querySelectorAll(".videoplayer").forEach(function (element) {
    element.addEventListener("click", () => {
        document.querySelector('.videoplayer').close();
        document.querySelector("body").classList.remove("noScroll");
    });
});


// Register dialog for backward compatibility
dialogPolyfill.registerDialog(document.querySelector('.videoplayer'));